import GlobalIcon2 from "../icons/globalIcon2";
export default function Line1a() {
  return (
    <div className="flex justify-start gap-4 
    || text-sm text-black222 font-semibold 
    || mb-c22">
      <div className="flex justify-center items-center gap-2">
        <GlobalIcon2 />
        <span>English (US) </span>
      </div>
      <span className="flex gap-c10">
        <span>$</span> <span>USD</span>
      </span>
    </div>
  );
}
